<template>
  <main>
    <div class="main_top">
      <h1>
        <img src="images/basic/icon/back.svg" onclick="history.back()" class="back">
      </h1>
      <div class="writer">
        <div class="profile_pic" :style="`background-image: url(${$store.state.userInfo.myPhotoUrl});`">
        </div>
        <div class="user">
          <span style="display:none;">Lv.1 </span>
          <span>{{ $store.state.userInfo.name }}</span>
          <!-- <p><select name="" id=""><option value="">전체공개</option><option value="">파티공개</option><option value="">비공개</option></select></p> -->
        </div>
        <!--<a href="javascript:chk_form();" class="submit">작성완료</a>-->
        
        <a @click="writePost" class="submit">작성완료</a>
      </div>
    </div>

    <div class="view_wrapper write_wrapper">
      <div class="div_padding"></div>
      <div class="content write-form">
        <form name="frm" method="post" action="/community_write" enctype="multipart/form-data">
          <select class="board_sel" name="boardId" v-model="boardId" disabled>
            <option v-for="menu in resultList" :key="menu.boardId" :value="menu.boardId">{{ menu.boardNm }}</option>
          </select>


          <!-- file list -->
          <div id="file_list">
            <div v-for="file in fileList" :key="file.name">
              <template v-if="file.type != 'image'">
                <div class="attached">
                  <a href="javascript:void(0)" class="file-name" v-html="file.name"></a>
                  <a href="javascript:void(0)" @click="deleteFile(file)"><img src="images/basic/icon/trash-b.svg" alt="" /></a>
                </div>
              </template>
            </div>
          </div>

          <!--
          <div id="file_list">
            <div v-for="file in fileList" :key="file.name">
              <div class="attached" ><a href="#" class="file-name" v-html="file.name"></a>
                <a href="#" @click="deleteFile(file)" ><img src="images/basic/icon/trash-b.svg" alt="" ></a>
              </div>
            </div>
          </div>
          -->
          
          <textarea name="nttCn" rows="8" id="nttCn" v-model="nttCn"></textarea>

          <img-list-form v-for="(img, idx) in boardDetail.imgViewList" :key="idx" :img="img" @deleteImg="deleteImg"></img-list-form>
          <div id="file_list">
            <div v-for="file in fileList" :key="file.name">
              <template v-if="file.type == 'image'">
                <div style="padding-top: 5px">
                  <div class="img_box" @click="file.isActive = !file.isActive">
                    <img :src="file.url" alt="" srcset="" style="width: 100%; height: auto;">
                    <div class="del_box" :class="{ on: file.isActive }">
                      <div class="btn_box" @click.prevent="deleteFile(file)">
                        <img src="/images/basic/icon/icon-del-photo.svg" alt="">
                        <p>삭제</p>
                      </div>
                    </div>
                  </div>
                </div>  
              </template>
            </div>
          </div>

          <div class="chat_option">
            <div class="" id="btn_camera">
              <label for="cameraFileInput">
                <i class="fas fa-camera"></i>
                <input
                  id="cameraFileInput"
                  type="file"
                  accept="image/*"
                  capture="environment"
                  name="camera_file"
                  style="display:none;"
                  ref="camera"
                  @change='cameraInputChange($event)'
                  @click="clearInput($event)"
                  />
              </label>
            </div>
            <div class="album">
              <label for="albumFileInput">
                <i class="fas fa-image"></i>
                <input
                    id="albumFileInput"
                    type="file"
                    accept="image/*"
                    name="album_file"
                    style="display:none;"
                    @change='albumInputChange($event)'
                    @click="clearInput($event)"
                    />
                </label>
            </div>
            <div class="attach">
              <label for="allFileInput">
                <i class="fas fa-link"></i>
                <input
                  id="allFileInput"
                  type="file"
                  name="all_file"
                  style="display:none;"
                  @change='allInputChange($event)'
                  @click="clearInput($event)"
                  />
              </label>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="overlay">
      <div class="spinner center">
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
      </div>
    </div>

  </main>
</template>

<script>
import ImgListForm from './ImgListForm.vue'
import { updateBoard, deleteFile, fetchWriteCommunityTabList, fetchBoardDetail } from '@/api/boards'
export default {
  components: {
    ImgListForm
  },
  created() {
    this.fetchData();
  },
  mounted() {
    window.$( document ).ready( function () {
        window.$( 'textarea' ).focus();
      });


  },
  data() {
    return {
      resultList: [],
      fileArray: [],
      fileList: [],
      nttCn: '',
      boardId: '',
      boardDetail: {},
      toggleOverlay: false,
      modifyRequested: false,
    }
  },
  methods: {
    fetchData() {
      const boardId = this.$route.query.boardId;
      const nttId = this.$route.query.nttId;
      fetchWriteCommunityTabList()
         .then(({ data }) => {
           this.resultList = data.resultList;
         })
         .then(() => {
           fetchBoardDetail({
               boardId,
               nttId,
               editFlag:"Y"
             })
             .then(({ data }) => {
               this.boardDetail = data.result;
             })
             .then(() => {
               this.boardId = this.boardDetail.boardId;
               this.nttCn = this.boardDetail.nttCn;
               this.boardDetail.flieList.filter(file => {
                 var fileObj = new Object();
                 fileObj.name = file.orignlFileNm;
                 fileObj.atchFileId = file.atchFileId;
                 fileObj.fileSn = file.fileSn;
                 this.fileArray.push(fileObj);
               })
               this.updateFileList();
             })
             .catch((error) => {
               console.log(error);
             })
         })
         .catch((error) => {
           console.log(error);
         })
      },
      updateFileList() {
        this.fileList = this.fileArray
      },
      deleteFile(file) {
        if(file.atchFileId) {
          deleteFile({
            atchFileId: file.atchFileId,
            fileSn: file.fileSn,
            boardId: this.$route.query.boardId,
            nttId: this.$route.query.nttId
          })
          .then(({ data }) => {
            //console.log(data)
            if(data.resultCode == 1000) {
              const idx = this.fileArray.findIndex(i => i.name == file.name);
              this.fileArray.splice(idx, 1);
              this.updateFileList()
            }
          })
          .catch((error) => {
            console.log(error);
          })
        } else {
          const idx = this.fileArray.findIndex(i => i.name == file.name); 
          this.fileArray.splice(idx, 1)
          this.updateFileList()
        }
      },
      writePost(){
        let boardId = this.boardId;
        let nttId = this.$route.query.nttId
        let nttCn = this.nttCn;//.replace(/(?:\r\n|\r|\n)/g,'</br>');
        
        if(nttCn == undefined || nttCn.trim() == ""){
          alert("게시글의 내용을 작성해 주세요.");
          return;
        }
        if(nttCn.trim().length < 10){
          alert("게시글의 내용을 10자 이상 작성해 주세요.");
          return;
        }

        if(this.modifyRequested) return;
        this.modifyRequested = true;
        
        var frm = new FormData();
        frm.append("boardId", boardId);
        frm.append("nttId", nttId)
        frm.append("nttCn", nttCn);
        for(let i=0 ; i<this.fileArray.length ; i++){
          var fileObj = this.fileArray[i];
          if(!fileObj.atchFileId) {
             frm.append("file"+ i, fileObj.file);
          }
        }

        window.$(".overlay").addClass("on");

        updateBoard(frm)
        .then((response) => {
          window.$(".overlay").removeClass("on");
          this.modifyRequested = false;
          // 응답 처리
//          console.log(response);
          this.$router.go(-1)
        })
        .catch((error) => {
          window.$(".overlay").removeClass("on");
          this.modifyRequested = false;
          console.log(error);
          // 예외 처리
        })
    },
    clearInput(e){
      e.target.value = ''
    },
    cameraInputChange(e) {
      this.pushFile(e);
    },
    albumInputChange(e) {
      this.pushFile(e);
    },
    allInputChange(e) {
      this.pushFile(e);
    },
    pushFile(e){
      var file = e.target.files[0];
      var fileObj = new Object();
      var fileType = "etc";
      if(file.type.includes("image")){
        fileType = "image";
        fileObj.url = window.URL.createObjectURL(file);
      }
      fileObj.index = this.fileArray.length;
      fileObj.name = file.name;
      fileObj.file = file;
      fileObj.type = fileType;
      fileObj.isActive = false;
      this.fileArray.push(fileObj);
      this.updateFileList();
    },
    deleteImg(fileSn) {
      this.boardDetail.imgViewList.forEach((img, idx) => {
        if(img.fileSn == fileSn) {
          this.boardDetail.imgViewList.splice(idx, 1)
        }
      })
    },
  },
}
</script>

<style scoped>
  .img_box {position:relative;}
  .img_box .del_box.on {display:block;}
  .img_box .del_box {display:none;position:absolute; width:100%; height:100%; background-color:rgba(0,0,0,0.8); top:0; left:0;}
  .img_box .del_box .btn_box {position:absolute; top:calc(50% - 23px); left:calc(50% - 13px); text-align: center;}
  .img_box .del_box .btn_box img {max-width:26px;}
  .img_box .del_box .btn_box p {color:#fff; font-size:14px;}
</style>